import { useApi } from "@kamae-apps/shared/Hooks/useApi"
import { getBeltColor } from "@kamae-apps/shared/Types/Belt"
import { useCallback } from "react"
import { useUser } from "../Contexts/User/UserContext"
import config from "../variable"

export const useAvatars = () => {
  const { user } = useUser()
  const { data: avatars } = useApi<string[]>("/avatar")

  const getAvatarUrl = useCallback(
    (avatar?: string) => {
      return avatar ? `${config.api}/avatar/${avatar}/${getBeltColor(user.level ?? 0)}` : "/avatar/avatar-v2-unknown.png"
    },
    [user]
  )
  const getRoundedAvatarUrl = useCallback((avatar?: string) => {
    return avatar ? `${config.api}/avatar/${avatar}/rounded_large` : "/avatar/rounded-avatar-v2-unknown.png"
  }, [])

  return {
    avatars,
    getAvatarUrl,
    getRoundedAvatarUrl,
  }
}
